import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { ILabel } from '@app/pages/settings/interfaces/labels.interfaces';
import { LabelBadgeComponent } from '@app/pages/settings/labels/label-item-row/label-badge/label-badge.component';
import { FormFieldLabelComponent } from '../../ui-components/form-field-label/form-field-label.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { LabelsListComponent } from '@app/shared/ui-components/labels-list/labels-list.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'entity-labels-section',
	imports: [
		CommonModule,
		LabelBadgeComponent,
		FormFieldLabelComponent,
		FormFieldLabelComponent,
		MatButtonModule,
		MatIconModule,
		MatMenuModule,
		LabelsListComponent,
		NgxTolgeeModule,
		MatChipsModule,
	],
	templateUrl: './entity-labels-section.component.html',
	styleUrl: './entity-labels-section.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityLabelsSectionComponent {
	selectedLabels = input<ILabel[]>();
	showAsChip = input<boolean>(false);
	labelsChanged = output<ILabel[]>();

	isMenuOpen = signal<boolean>(false);

	onLabelsChanged(labels: ILabel[]) {
		this.labelsChanged.emit(labels);
	}

	unlinkLabel(label: ILabel) {
		const newLabelList = this.selectedLabels().filter(l => l.pk !== label.pk);
		this.labelsChanged.emit(newLabelList);
	}
}
